
import EditUserForm from '@/components/Management/User/EditUserForm';

export default {
  components: {
    EditUserForm
  }
};
